"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var _a;

var React = __importStar(require("react"));

var components_1 = require("../../components");

var constants_1 = require("../../constants");

var PlayerError_1 = __importDefault(require("../../utils/PlayerError"));

var HbbTvPlayState;

(function (HbbTvPlayState) {
  HbbTvPlayState[HbbTvPlayState["STOPPED"] = 0] = "STOPPED";
  HbbTvPlayState[HbbTvPlayState["PLAYING"] = 1] = "PLAYING";
  HbbTvPlayState[HbbTvPlayState["PAUSED"] = 2] = "PAUSED";
  HbbTvPlayState[HbbTvPlayState["CONNECTING"] = 3] = "CONNECTING";
  HbbTvPlayState[HbbTvPlayState["BUFFERING"] = 4] = "BUFFERING";
  HbbTvPlayState[HbbTvPlayState["FINISHED"] = 5] = "FINISHED";
  HbbTvPlayState[HbbTvPlayState["ERROR"] = 6] = "ERROR";
})(HbbTvPlayState = exports.HbbTvPlayState || (exports.HbbTvPlayState = {}));

var HbbTvVideoFormat;

(function (HbbTvVideoFormat) {
  HbbTvVideoFormat["LEGACY"] = "dashhbbtv";
  HbbTvVideoFormat["PREFERRED"] = "dash-hbbtv";
})(HbbTvVideoFormat = exports.HbbTvVideoFormat || (exports.HbbTvVideoFormat = {}));

var HbbTvErrors;

(function (HbbTvErrors) {
  HbbTvErrors[HbbTvErrors["FormatNotSupported"] = 0] = "FormatNotSupported";
  HbbTvErrors[HbbTvErrors["ServerConnection"] = 1] = "ServerConnection";
  HbbTvErrors[HbbTvErrors["Unidentified"] = 2] = "Unidentified";
  HbbTvErrors[HbbTvErrors["InsufficientResources"] = 3] = "InsufficientResources";
  HbbTvErrors[HbbTvErrors["ContentCorruptOrInvalid"] = 4] = "ContentCorruptOrInvalid";
  HbbTvErrors[HbbTvErrors["ContentNotAvailable"] = 5] = "ContentNotAvailable";
  HbbTvErrors[HbbTvErrors["NoContentAtPosition"] = 6] = "NoContentAtPosition";
})(HbbTvErrors || (HbbTvErrors = {}));

var ErrorMessages = (_a = {}, _a[HbbTvErrors.FormatNotSupported] = 'A/V format not supported', _a[HbbTvErrors.ServerConnection] = 'cannot connect to server or connection lost', _a[HbbTvErrors.Unidentified] = 'unidentified error', _a[HbbTvErrors.InsufficientResources] = 'insufficient resources', _a[HbbTvErrors.ContentCorruptOrInvalid] = 'content corrupt or invalid', _a[HbbTvErrors.ContentNotAvailable] = 'content not available', _a[HbbTvErrors.NoContentAtPosition] = 'content not available at given position', _a); // TODO: Which types of errors should be fatal?

var FATAL_ERRORS = [HbbTvErrors.FormatNotSupported, HbbTvErrors.ServerConnection, HbbTvErrors.Unidentified, HbbTvErrors.InsufficientResources, HbbTvErrors.ContentCorruptOrInvalid, HbbTvErrors.ContentNotAvailable, HbbTvErrors.NoContentAtPosition];
var LEGACY_DEFAULT_SUBLANG = 'defaultSubLang=1';
var LEGACY_EXCLUDE_BITRATES = 'excludeBitrates=240,348,456,636&b=750-';

var HbbTvBackend =
/** @class */
function (_super) {
  __extends(HbbTvBackend, _super);

  function HbbTvBackend() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.objectElement = null;
    _this.controller = null;
    return _this;
  }

  HbbTvBackend.prototype.safeComponentDidMount = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (this.objectElement === null) {
          throw new PlayerError_1["default"]('VideoElement cannot be null in componentDidMount', {
            fatal: true
          });
        }

        this.controller = new HbbTvController(this.objectElement);

        if (this.props.onControllerChange) {
          this.props.onControllerChange(this.controller);
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  HbbTvBackend.prototype.render = function () {
    var _this = this;

    return React.createElement("object", {
      type: "application/dash+xml",
      title: "test",
      id: "player",
      className: this.props.className,
      ref: function ref(el) {
        return _this.objectElement = el;
      }
    });
  };

  return HbbTvBackend;
}(components_1.SafeAsyncComponent);

exports.HbbTvBackend = HbbTvBackend;

var HbbTvController =
/** @class */
function () {
  function HbbTvController(controlElement) {
    var _this = this;

    this.listeners = new Map();
    this.shouldSeek = false;

    this.onPlayStateChange = function (state) {
      var currentState = typeof state !== 'undefined' ? state : _this.controlElement.playState;

      switch (currentState) {
        case HbbTvPlayState.STOPPED:
          _this.dispatchState(constants_1.PlayerState.STOPPED);

          _this.stopPositionEmitter();

          break;

        case HbbTvPlayState.PLAYING:
          if (_this.shouldSeek && _this.pauseAtStartPosition) {
            _this.seekTo(_this.pauseAtStartPosition);

            _this.shouldSeek = false;
          }

          _this.dispatchState(constants_1.PlayerState.PLAYING);

          _this.startPositionEmitter();

          break;

        case HbbTvPlayState.PAUSED:
          _this.dispatchState(constants_1.PlayerState.PAUSED);

          _this.updatePosition(); // Update position after seek


          _this.stopPositionEmitter();

          break;

        case HbbTvPlayState.CONNECTING:
          _this.dispatchState(constants_1.PlayerState.LOADING);

          _this.stopPositionEmitter();

          break;

        case HbbTvPlayState.BUFFERING:
          _this.dispatchState(constants_1.PlayerState.BUFFERING);

          _this.stopPositionEmitter();

          break;

        case HbbTvPlayState.FINISHED:
          _this.dispatchState(constants_1.PlayerState.ENDED);

          _this.stopPositionEmitter();

          break;

        case HbbTvPlayState.ERROR:
          _this.dispatchError();

          _this.stopPositionEmitter();

          break;
      }

      return currentState;
    };

    this.updatePosition = function () {
      _this.dispatchEvent('positionUpdate', {
        duration: _this.controlElement.playTime / 1000,
        position: _this.getCurrentPlayerPositionMs() / 1000
      });
    };

    this.controlElement = controlElement;
    this.pauseAtStartPosition = null;
    this.controlElement.onPlayStateChange = this.onPlayStateChange; // Leave until we know how these behave on different TVs

    this.controlElement.onPlayPositionChanged = function (pos) {
      // tslint:disable-next-line
      console.warn('onPlayPositionChanged (could maybe be used for later for event filtering)', pos);
    };

    this.controlElement.onReadyToPlay = function () {
      console.warn('onReadyToPlay (could be used to fix flutter)'); // tslint:disable-line
    };
  }

  HbbTvController.prototype.addEventListener = function (eventName, callback) {
    var arr = this.listeners.get(eventName);

    if (arr) {
      arr.push(callback);
    } else {
      this.listeners.set(eventName, [callback]);
    }
  };

  HbbTvController.prototype.removeEventListener = function (eventName, callback) {
    var arr = this.listeners.get(eventName);

    if (arr) {
      var index = arr.indexOf(callback);

      if (index !== -1) {
        arr.splice(index, 1);
      }
    }
  };

  HbbTvController.prototype.dispose = function () {
    this.stopPositionEmitter();
  };

  HbbTvController.prototype.getUrl = function () {
    return this.controlElement.data;
  };

  HbbTvController.prototype.getVolume = function () {
    return 0.25;
  };

  HbbTvController.prototype.isMute = function () {
    return false;
  };

  HbbTvController.prototype.loadVideo = function (streamInfo, options) {
    var dashReference = this.getVideoReference(streamInfo);

    if (dashReference) {
      this.controlElement.data = dashReference;

      if (options && typeof options.startPosition !== 'undefined') {
        this.pauseAtStartPosition = options.startPosition;
        this.shouldSeek = true;
        this.controlElement.play(0);
      }

      if (options && options.autoPlay) {
        this.controlElement.play(1);
      }
    }
  };

  HbbTvController.prototype.mute = function () {// No-op until tested
  };

  HbbTvController.prototype.unMute = function () {// No-op until tested
  };

  HbbTvController.prototype.seekTo = function (time) {
    this.controlElement.seek(time * 1000);
  };

  HbbTvController.prototype.setMaxVideoBitrate = function (bitrate) {// No-op on the TV(?)
    // this.controlElement.setRepresentationStrategyStrategy(bitrate, 0, );
  };

  HbbTvController.prototype.setVolume = function (volume) {// No-op until tested
  };

  HbbTvController.prototype.stop = function () {
    throw new Error('Method not implemented.');
  };

  HbbTvController.prototype.pause = function () {
    this.controlElement.play(0);
  };

  HbbTvController.prototype.play = function () {
    this.controlElement.play(1);
  };

  HbbTvController.prototype.getMaximumPosition = function () {
    return 0; // TODO
  };

  HbbTvController.prototype.getVideoReference = function (streamInfo) {
    if (streamInfo.videoReferences[HbbTvVideoFormat.PREFERRED]) {
      return streamInfo.videoReferences[HbbTvVideoFormat.PREFERRED];
    }

    var legacy = streamInfo.videoReferences[HbbTvVideoFormat.LEGACY];

    if (!legacy) {
      return '';
    }

    return this.fixLegacyUrl(legacy);
  };
  /**
   * Removes defaultSubLang. Embedded subtitles are sometimes forced and can
   * not be turned off on certain HbbTv devices.
   *
   * @param query string
   */


  HbbTvController.prototype.removeSubLang = function (query) {
    return query.replace(LEGACY_DEFAULT_SUBLANG, '');
  };

  HbbTvController.prototype.removeAltUrl = function (query) {
    return query.replace(/alt.*?(&|$)/, '');
  };
  /**
   * Always load high bitrate on TV
   *
   * @param query string
   */


  HbbTvController.prototype.addLegacyBitrates = function (query) {
    if (query.length > 0) {
      query += '&' + LEGACY_EXCLUDE_BITRATES;
    } else {
      query = LEGACY_EXCLUDE_BITRATES;
    }

    return query;
  };

  HbbTvController.prototype.fixLegacyUrl = function (legacy) {
    var firstQuestionMark = legacy.indexOf('?');
    var query = '';
    var base = '';

    if (firstQuestionMark > -1) {
      query = legacy.substring(firstQuestionMark + 1);
      base = legacy.substring(0, firstQuestionMark);
    } else {
      base = legacy;
    }

    query = this.removeSubLang(query);
    query = this.removeAltUrl(query);
    query = this.addLegacyBitrates(query);
    return base + "?" + query;
  };

  HbbTvController.prototype.startPositionEmitter = function () {
    this.updatePosition(); // run directly

    this.positionUpdateTimer = window.setInterval(this.updatePosition, 1000);
  };

  HbbTvController.prototype.stopPositionEmitter = function () {
    if (this.positionUpdateTimer) {
      window.clearInterval(this.positionUpdateTimer);
    }
  };

  HbbTvController.prototype.dispatchError = function () {
    var errorCode = this.controlElement.error;

    if (typeof errorCode !== 'number') {
      return this.dispatchEvent('error', new PlayerError_1["default"]('Received error state but controlElement does not report error', {
        fatal: false
      }));
    }

    var errorType = HbbTvErrors[errorCode];

    if (typeof errorType === 'undefined') {
      return this.dispatchEvent('error', new PlayerError_1["default"]("HbbTV error code " + errorCode + " not expected", {
        fatal: false
      }));
    }

    var fatal = FATAL_ERRORS.indexOf(errorCode) > -1;
    var errorMessage = ErrorMessages[errorCode];
    console.error('PlaybackError', errorMessage);
    this.dispatchEvent('error', new PlayerError_1["default"](errorMessage, {
      fatal: fatal
    }));
  };

  HbbTvController.prototype.dispatchState = function (playerState) {
    this.dispatchEvent('playerStateChange', playerState);
  };

  HbbTvController.prototype.getCurrentPlayerPositionMs = function () {
    if (this.controlElement.mediaPlayInfo) {
      return this.controlElement.mediaPlayInfo().currentPosition;
    } else if (typeof this.controlElement.playPosition !== 'undefined') {
      return this.controlElement.playPosition;
    }

    return 0;
  };

  HbbTvController.prototype.dispatchEvent = function (eventName, payload) {
    var arr = this.listeners.get(eventName);

    if (arr) {
      arr.forEach(function (callback) {
        return callback(payload);
      });
    }
  };

  return HbbTvController;
}();

exports.HbbTvController = HbbTvController;
exports["default"] = HbbTvBackend;